(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui-universal/primitive-utilities"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities")) : factory(root["underscore"], root["@bingads-webui-universal/primitive-utilities"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 139);
/******/ })
/************************************************************************/
/******/ ({

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(140);


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(141);

Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _index[key];
    }
  });
});

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bulkify = __webpack_require__(142);

Object.keys(_bulkify).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bulkify[key];
    }
  });
});

var _bulkUpsertUtil = __webpack_require__(143);

Object.keys(_bulkUpsertUtil).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bulkUpsertUtil[key];
    }
  });
});

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serialize = serialize;
exports.parse = parse;
exports.findEntityWithClientId = findEntityWithClientId;
exports.populateIds = populateIds;

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
// this is for backward compatibility. legacy code put schema to property named schema
function getSchemaOfSubAttr(schema, attrName) {
  if (schema.properties[attrName].type === 'array') {
    return schema.properties[attrName].items.schema || schema.properties[attrName].items;
  }

  return schema.properties[attrName].schema || schema.properties[attrName];
} // this is for backward compatibility. new schema put name in $$ODataExtension


function getSchemaName(schema) {
  return schema.name || schema.$$ODataExtension.Name;
}

function serialize(schema, attrs) {
  var rows = getCSVRows(schema, attrs);
  var formatRow = {
    Type: 'Format Version',
    Name: '6'
  };
  rows.splice(0, 0, formatRow);
  return generateCsvRows(rows);
}

function getCSVRows(rootSchema, attributesList, clientIdPrefix) {
  var csvRows = []; //ensuring that the input list is an array (first level entity is always a solo object)

  if (!_underscore.default.isArray(attributesList)) {
    attributesList = [attributesList];
  }

  var traverses = [];
  var clientIds = [];

  _underscore.default.each(attributesList, function (attributes, index) {
    if (!_underscore.default.isString(attributes['Client Id']) && !_underscore.default.isNumber(attributes['Client Id']) || _underscore.default.contains(clientIds, attributes['Client Id'])) {
      attributes['Client Id'] = (clientIdPrefix ? clientIdPrefix + '-' : '') + index.toString();
    }

    var traverseResult = traverseFields(attributes, rootSchema);
    traverses.push(traverseResult);
    clientIds.push(attributes['Client Id']);
  });

  var nextRootResults = [];

  _underscore.default.each(traverses, function (rowResult, rowIndex) {
    var attributes = rowResult.attributes,
        currentRow = rowResult.currentRow,
        nextRoots = rowResult.nextRoots,
        nextRootSchemas = rowResult.nextRootSchemas;

    if (rootSchema.properties['bulk-upload-type']) {
      currentRow['Type'] = rootSchema.properties['bulk-upload-type'].value;
    }

    csvRows.push(currentRow);

    _underscore.default.each(nextRoots, function (nextRoot, index) {
      var csvRows = getCSVRows(nextRootSchemas[index], attributes[nextRoot], clientIds[rowIndex] + '-' + index.toString());
      nextRootResults.push(csvRows);
    });
  });

  _underscore.default.each(_underscore.default.flatten(nextRootResults, true), function (row) {
    csvRows.push(row);
  });

  return csvRows;
}

function getCsvHeaderName(attr, schema) {
  return !_underscore.default.isUndefined(schema.properties[attr]['bulk-upload-header']) ? schema.properties[attr]['bulk-upload-header'] : attr;
}

function getCsvValue(attr, schema, value) {
  if (_underscore.default.isNull(value) || schema.properties[attr].bulkDeleteValueIfEmpty && (_underscore.default.isString(value) && _underscore.default.isEmpty(value.trim()) || _underscore.default.isEmpty(value))) {
    return 'delete_value';
  }

  var func = schema.properties[attr]['bulk-upload-mapper'];
  value = !_underscore.default.isFunction(func) ? value : func(value);

  if (_underscore.default.contains(value, '"')) {
    value = value.replace(/"/g, '""');
  }

  if (_underscore.default.contains(value, ',') || _underscore.default.contains(value, '"')) {
    value = '"' + value + '"';
  }

  return value;
} //traversing fields for each set of attributes in the list, returning:
//- currentRow: data to send to MT for the given object(csv header names and values)
//- nextRoots: inner objects that need to be traversed again for new data (like when Campaign includes AdGroups)
//- nextRootSchemas: Schemas to be used for the next inner objects (based on their type).
//- attributes: attributes that are passed to the function with the client Ids added to them.


function traverseFields(attrs, schema) {
  var currentRow = {},
      nextRoots = [],
      nextRootSchemas = [];

  _underscore.default.each(attrs, function (value, attr) {
    if (attr === 'Client Id') {
      currentRow[attr] = value;
      return;
    } //reject the function if there is any attribute not found in the schema


    if (!_underscore.default.has(schema.properties, attr)) {
      throw new Error('invalid property ' + attr + ' is passed!');
    }

    var innerPropertySchema = null; //deciding if the current attr has schema

    if (schema.properties[attr].type === 'object' || schema.properties[attr].type === 'array') {
      innerPropertySchema = getSchemaOfSubAttr(schema, attr);
    }

    ;

    if (innerPropertySchema) {
      //skipping the budget schema as it has the Id but it shouldn't be considered as a root entity
      //todo [imang]: this should be a temporary fix. We have to think this through and find the optimal solution to find root entities
      // todo: SharedEntityAssociation is root, however it has EntityId and SharedEntityId, but not Id
      var isRootEntity = getSchemaName(innerPropertySchema) === 'SharedEntityAssociation' || getSchemaName(innerPropertySchema) !== 'Budget' && getSchemaName(innerPropertySchema) !== 'AssetLink' && _underscore.default.has(innerPropertySchema.properties, 'Id'); //deciding if the attr is a foreign key link or a complete object needs to be further traversed


      var attrKeys = _underscore.default.keys(value);

      var isObjectAForeignKey = schema.properties[attr].type === 'object' && _underscore.default.size(attrKeys) === 1 && attrKeys[0] === 'Id';

      if (isRootEntity) {
        if (isObjectAForeignKey) {
          //todo [imang]: currently the only relationship defined and handled in the adapter is the Parent Relationship. Should make this more generic in the future.
          currentRow['Parent ID'] = value['Id'];
        } else {
          nextRoots.push(attr);
          nextRootSchemas.push(innerPropertySchema);
        }
      } else if (schema.properties[attr]['bulk-upload-mapper']) {
        // check if it needs custom mapping
        currentRow[getCsvHeaderName(attr, schema)] = getCsvValue(attr, schema, value);
      } else if (getSchemaOfSubAttr(schema, attr)['bulk-upload-full-mapper']) {
        if (_underscore.default.isFunction(getSchemaOfSubAttr(schema, attr)['bulk-upload-full-mapper'])) {
          var keyValues = getSchemaOfSubAttr(schema, attr)['bulk-upload-full-mapper'](value);

          _underscore.default.each(keyValues, function (pair) {
            currentRow[pair.key] = pair.value;
          });
        }
      } else {
        //if the loaded schema is not representing a root entity
        //extract the values from inside and populate to the current row object (e.g. Budget)
        //TODO [imang]: currently only supports one level traversal
        // TODO [imang]: handling special case for the Budget entity that has other properties that should be skipped.
        var propsToIterate = getSchemaName(innerPropertySchema) === 'Budget' ? _underscore.default.pick(innerPropertySchema.properties, 'Amount', 'Type') : innerPropertySchema.properties;

        for (var prop in propsToIterate) {
          currentRow[getCsvHeaderName(prop, innerPropertySchema)] = getCsvValue(prop, innerPropertySchema, value[prop]);
        }
      }
    } else {
      if (schema.properties[attr]['bulk-upload-flattened']) {
        if (schema.properties[attr]['bulk-upload-enum']) {
          var enumIndex = schema.properties[attr].enum.indexOf(value);
          var csvHeaderName = schema.properties[attr]['bulk-upload-enum'][enumIndex];
          currentRow[csvHeaderName] = 'ON';
        }
      } else if (_underscore.default.isFunction(schema.properties[attr]['bulk-upload-full-mapper'])) {
        var pairs = schema.properties[attr]['bulk-upload-full-mapper'](value);

        _underscore.default.each(pairs, function (pair) {
          currentRow[pair.key] = pair.value;
        });
      } else {
        currentRow[getCsvHeaderName(attr, schema)] = getCsvValue(attr, schema, value);
      }
    }
  });

  return {
    attributes: attrs,
    currentRow: currentRow,
    nextRoots: nextRoots,
    nextRootSchemas: nextRootSchemas
  };
}

function getCsvColumns(rows) {
  return _underscore.default.uniq(_underscore.default.union(_underscore.default.flatten(_underscore.default.map(rows, function (row) {
    return _underscore.default.keys(row);
  })), ['Id', 'Parent ID']));
}

function generateCsvRows(rows) {
  var columns = getCsvColumns(rows),
      result = []; //first line is the list of columns

  var line = columns.join();
  result.push(line);

  _underscore.default.each(rows, function (row) {
    line = '';

    _underscore.default.each(columns, function (column) {
      line += (_underscore.default.has(row, column) && !_underscore.default.isUndefined(row[column]) ? row[column] : '') + ',';
    });

    line = line.slice(0, -1);
    result.push(line);
  });

  return result;
}

function convertCsvDataInTextToCsvArray(csvData) {
  var csvDataArray = [];
  var csvDataRows = [];
  var pos = 0;

  while (pos < csvData.length - 1) {
    csvDataArray.push(csvData.slice(pos, csvData.indexOf('\n', pos) - 1));
    pos = csvData.indexOf('\n', pos) + 1;
  }

  _underscore.default.each(csvDataArray, function (csvDataRow) {
    var rowData = csvDataRow.split(',');
    csvDataRows.push(rowData);
  });

  return csvDataRows;
}

function parse(csvData, isTextType) {
  var results = [];

  if (!_underscore.default.isUndefined(isTextType)) {
    csvData = convertCsvDataInTextToCsvArray(csvData);
  }

  var headers = csvData[0]; //first line is header, second line is format version. needs to be skipped.

  var data = csvData.slice(2);

  _underscore.default.each(data, function (row) {
    var obj = {};

    for (var col = 0; col < row.length; col++) {
      obj[headers[col]] = row[col];
    }

    results.push(obj);
  });

  var errors = getErrorRows(results);
  return {
    results: results,
    errors: errors
  };
}

function findEntityWithClientId(data, clientId) {
  if (!_underscore.default.isArray(data)) {
    if (data['Client Id'] === clientId) {
      return data;
    } else {
      for (var attr in data) {
        if (_underscore.default.isArray(data[attr])) {
          return findEntityWithClientId(data[attr], clientId);
        }
      }
    }
  } else {
    _underscore.default.each(data, function (singleData) {
      var ret = findEntityWithClientId(singleData, clientId);

      if (ret) {
        return ret;
      }
    });
  }

  return null;
}

function setId(data, clientId, id) {
  if (!_underscore.default.isArray(data)) {
    if (data['Client Id'] === clientId) {
      data['Id'] = id; //delete data['Client Id'];

      return;
    } else {
      for (var attr in data) {
        if (_underscore.default.isArray(data[attr])) {
          setId(data[attr], clientId, id);
        }
      }
    }
  } else {
    _underscore.default.each(data, function (singleData) {
      setId(singleData, clientId, id);
    });
  }
}

function populateIds(csvData, clientData) {
  var ret = clientData;

  _underscore.default.each(csvData, function (csvRow) {
    if (csvRow['Id']) {
      setId(ret, csvRow['Client Id'], csvRow['Id']);
    }
  });

  return ret;
}

function getErrorRows(csvData) {
  var errors = _underscore.default.filter(csvData, function (item) {
    return item.Type.indexOf(' Error') > -1;
  }); //Parsing error process-> Property-> EditorialCode->ErrorNumber->Error


  return _underscore.default.map(errors || [], function (error) {
    return {
      'EditorialCode': error['Editorial Reason Code'] || '',
      'EditorialLocation': error['Editorial Location'] || '',
      'EditorialTerm': error['Editorial Term'] || '',
      'ErrorNumber': error['Error Number'] || '',
      'Property': error['Field Path'] || '',
      'Error': error.Error || '',
      'Client Id': error['Client Id'] || '',
      'Type': error.Type || '',
      'Id': error.Id || '',
      'Parent Id': error['Parent Id'] || ''
    };
  });
}

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUri = getUri;
exports.extractEntityErrors = extractEntityErrors;
exports.buildDestroyObject = buildDestroyObject;
exports.hasReadOnlyFields = hasReadOnlyFields;
exports.getAttrsToSerialize = getAttrsToSerialize;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _primitiveUtilities = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODOs [imang]:
// 1. functions to build odata Uri should be generalized
// in odata-core and be removed from this file.
// 2. error handling: errors should be propagated all the way
// to their place inside the object hierarchy.
// for now, they are aggregated in the errors field in the top level of
// each returned instance to the caller.
// 3. referencing should only be implicitly done by the caller.
// for now, all sub-entities inside Campaigns/AdGroups
// should explicitly specify either the Campaign/AdGroupId
// or Campaign/AdGroupName fields in order to define the relationship.
// this should be changed in a way that adapter finds
// the related ids based on the hierarchy definition.
function getCast(options) {
  return options && !_underscore.default.isEmpty(options.cast) ? `/${options.cast}` : '';
}

function getParent(options) {
  return options && !_underscore.default.isEmpty(options.parent) ? `${options.parent}/` : '';
}

function getUri(options) {
  return `/Customers(:advertisercustomer_id)/Accounts(:account_id)/${getParent(options)}Default.BulkUpsert${getCast(options)}`;
}

function extractEntityErrors(errors, index) {
  return _underscore.default.filter(errors, error => parseInt(error['Client Id'][0], 10) === index);
}

function buildDestroyObject(parent, id, parentId) {
  const obj = {
    Id: id,
    Status: 'Deleted'
  };
  const parentFkObject = {
    Id: _underscore.default.isUndefined(parentId) ? '' : parentId
  };
  obj[parent] = parentFkObject;
  return obj;
}

function buildCreateObject(attrs) {
  return _underscore.default.omit(attrs, 'Id');
}

function hasReadOnlyFields(attrs, properties) {
  return _underscore.default.some(attrs, (v, k) => properties[k] && properties[k].isReadOnly);
}

function getAttrsToSerialize(id, attrs, schema) {
  if (hasReadOnlyFields(attrs, schema.properties)) {
    const parentId = (0, _primitiveUtilities.get)((0, _primitiveUtilities.get)(attrs, schema.parent, {}), 'Id', undefined);
    return [buildDestroyObject(schema.parent, id, parentId), buildCreateObject(attrs)];
  }

  return _underscore.default.defaults(attrs, {
    Id: id
  });
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ });
});
